import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Button } from '@nf/ui';
import { useCheckMessages } from '@/hooks/query/use-account-messages';
import { Modal } from '@/components/widgets/modal';
import { AccountMessage } from '@/features/account-message';
import { useTranslations } from 'next-intl';
import { MessageIcon } from '@/components/icons/svg-icons';
import { userInfoStyle } from '@/features/profile/profile-panel/components/user-info/user-info.style';
import { KafkaNote } from '@nf/utils-common/constants';
import { headerStyle } from '@/jupiter/components/header/header.style';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useRouter } from '@/navigation';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';

interface MessageButtonProps {
	style: any;
	/** 是否打開引用此元件的頁面 (true: 重設紅點提示) */
	isOpened: boolean;
	fromPage: 'home' | 'me' | 'header';
}

/** [Mars] Message 入口 */
export const MessageButton = ({ style, isOpened, fromPage }: MessageButtonProps) => {
	const t = useTranslations('General');
	const view = useAppearanceStore(state => state.view);
	const [showBadge, setShowBadge] = useState(false);
	const [isOpen, setIsOpen] = useState(false);
	const { messagesInfo } = useCheckMessages();

	useEffect(() => {
		if (isOpened && messagesInfo) {
			const hasNewMessage = messagesInfo?.showPrivateMsg || messagesInfo?.showPublicMsg || messagesInfo?.showSpecialMsg;
			if (hasNewMessage) {
				setShowBadge(true);
			}
		}
	}, [isOpened, messagesInfo]);

	const toggleModal = () => {
		const nextIsOpen = !isOpen;
		setIsOpen(nextIsOpen);
		if (nextIsOpen) {
			setKafka();
			setShowBadge(false);
		}
	}

	const setKafka = () => {
		const isHomePage = fromPage === 'home';
		const kafkaData = {
			note: KafkaNote.MarsV1,
			type: isHomePage ? 1 : 7,
			action: isHomePage ? 1 : 18
		}
		setKafkaNormal(kafkaData);
	}

	const router = useRouter();
	const routerPush = () => {
		router.push('/message');
	}
	return (
		<>
			<Button
				className={style}
				variant="icon"
				shape={fromPage === 'header' ? undefined : 'round'}
				onClick={fromPage === 'header' && view === ViewEnum.galaxy ? routerPush : toggleModal}
			>
				<MessageIcon />
				{showBadge ? (
					fromPage === 'header'
						? <div className={headerStyle.badge}></div>
						: <div className={clsx('badge badge--point', userInfoStyle.badge)}></div>
				) : null}
			</Button >
			<Modal
				variant="full"
				title={t('Msg')}
				className={userInfoStyle.messageModal}
				isOpen={isOpen}
				closeModal={toggleModal}
			>
				<AccountMessage />
			</Modal>
		</>
	);
}